import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { OrderData } from '../../../../shared/models/order';
import { AztecCodeComponent } from '../aztec-code/aztec-code.component';
import { TranslateModule } from '@ngx-translate/core';
import { DanishTimePipe } from "../../../../services/utility/danish-time.pipe";

@Component({
    selector: 'app-inspection-modal',
    standalone: true,
    templateUrl: './inspection-modal.component.html',
    styleUrls: ['./inspection-modal.component.css'],
    imports: [CommonModule, TranslateModule, ModalComponent, AztecCodeComponent, DanishTimePipe],
})
export class InspectionModalComponent {
    @Input() isOpen = false;
    @Input() orderData: OrderData | null = null;
    @Input() isTicketValid = false;

    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }
}